import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '../../atoms';

const ModalAlert = ({
  title,
  text,
  textAction,
  textCancel,
  actionEvent,
  cancelEvent,
  onClose,
}) => (
  <Modal onClose={onClose}>
    <div className="modal-alert">
      <h3 className="modal-alert_title">
        {title}
      </h3>
      <p className="modal-alert_text">
        {text}
      </p>
      <div className="modal-alert_buttons">
        <div className="modal-alert_buttons__action">
          <Button
            label={textAction}
            onClick={() => actionEvent()}
            type="primary "
          />
        </div>

        <div className="modal-alert_buttons__cancel">
          <Button
            label={textCancel}
            onClick={() => cancelEvent()}
            type="primary--border"
          />
        </div>
      </div>
    </div>
  </Modal>
);

ModalAlert.defaultProps = {
  text: '',
  textAction: 'Confirmar',
  textCancel: 'Cancelar',
};

ModalAlert.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  textAction: PropTypes.string,
  textCancel: PropTypes.string,
  actionEvent: PropTypes.func.isRequired,
  cancelEvent: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalAlert;
